import { render, staticRenderFns } from "./FeedbacksTable.vue?vue&type=template&id=dd378530&"
import script from "./FeedbacksTable.vue?vue&type=script&lang=js&"
export * from "./FeedbacksTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports